import(/* webpackMode: "eager" */ "/home/ops/work/frontend/webrtc/app/page.tsx");
